import { CardStatuses } from '../types';

export interface HasBlackFontPredicator {
  values?: string[];
  identificationTypesToCheck?: string[];
  shouldCheckCardStatus?: boolean;
  cardStatusToCheck?: CardStatuses;
  identifications?: any[];
  cardStatus?: CardStatuses;
}

const defaultData = {
  values: ['200001', '200005'],
  identificationTypesToCheck: ['ProductIdentifier'],
  shouldCheckCardStatus: false,
  cardStatusToCheck: CardStatuses.Active,
  identifications: undefined,
  cardStatus: undefined,
};

const hasBlackFontPredicator = (data: HasBlackFontPredicator): boolean => {
  const { values, identificationTypesToCheck, identifications, shouldCheckCardStatus, cardStatusToCheck, cardStatus } =
    {
      ...defaultData,
      ...data,
    };

  const identificationValue = identifications?.find(identification =>
    identificationTypesToCheck?.includes(identification.type),
  )?.identifier?.value;

  if (shouldCheckCardStatus && cardStatus && cardStatusToCheck) {
    return values.includes(identificationValue) && cardStatus === cardStatusToCheck;
  }

  return values.includes(identificationValue);
};

export { hasBlackFontPredicator };
